import React from "react";

import { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";



export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const raw = sessionStorage.getItem("user");
    if (raw) {
      try {
        setUser(JSON.parse(raw));
      } catch (e) {
        console.warn("AuthContext: invalid stored user", e);
      }
    }
  }, []);

  const persistUser = (u) => {
    setUser(u);
    sessionStorage.setItem("user", JSON.stringify(u));
  };

  const handleLoginInReact = async (aml, pml, pg_id) => {
    const res = await fetch("/api-login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ aml, pml, pg_id }),
    });
    const data = await res.json();

    if (!data.success) throw new Error(data.message || "Anmeldung fehlgeschlagen");

    const userObj = {
      aml,
      // pml,
      pgid: data.pg_id || pg_id,
      session_id: data.session_id || data.sessionId,
      typ: data.typ,
      username: aml,
    };

    persistUser(userObj);
    return userObj;
  };

  const handleLogout = () => {
    sessionStorage.clear();
    setUser(null);
  };

  const loggedIn = !!user; // ✅ derive from state

  return (
    <AuthContext.Provider value={{ user, loggedIn, setUser, handleLoginInReact, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);